<template>
  <UiCard class="flex animate-pulse flex-col px-5 py-4">
    <div class="mb-1 h-4 w-1/2 rounded-lg bg-secondary" />
    <div class="mb-2 h-3.5 w-1/4 rounded-lg bg-secondary" />
    <div class="h-4 w-1/4 rounded-lg bg-secondary" />
  </UiCard>
</template>

<script setup lang="ts">
import { UiCard } from '@/6_shared/ui'
</script>
